// @flow strict

import { Button, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { IoFlash } from "react-icons/io5";
import useRemaining from '../../Hooks/useRemaining';
import { isRemainingExpired } from '../../Utility/utility';

const expiredMessage = "Your subscription has been expired. Please update your token to continue using the chat.";
const insufficientMessage = "Your chat token balance is insufficient to continue the chat. Please upgrade your plan to continue.";

function WarningModal() {
  const [openExpireModal, setOpenExpireModal] = useState(false);
  const [openInsufficientModal, setOpenInsufficientModal] = useState(false);
  const { userInfo, remaining, expireDate } = useRemaining();

  // useEffect(() => {
  //   if (userInfo?.role !== 'superadmin') {
  //     if (remaining?.token <= 0) {
  //       setOpenInsufficientModal(true);
  //       setOpenExpireModal(false);
  //     } else if (isRemainingExpired(remaining?.expireDate || expireDate) === true) {
  //       setOpenExpireModal(true);
  //       setOpenInsufficientModal(false);
  //     };
  //   }
  // }, [remaining, userInfo, expireDate]);

  return (
    <>
    
    </>
    // <Modal
    //   closable={true}
    //   footer={false}
    //   icon={<></>}
    //   open={openExpireModal || openInsufficientModal}
    //   onCancel={ () => setOpenInsufficientModal(false) }
    // >
    //   <div className="p-3 p-lg-3 d-flex flex-column gap-2 token-warning-modal mt-3">
    //     <div className="d-flex justify-content-center">
    //       <p className="modal-icon fs-1 rounded-circle bg-primary-subtle">
    //         <IoFlash className="text-primary" />
    //       </p>
    //     </div>
    //     <h3 className="text-center">Upgrade to Pro Plan!</h3>
    //     <p className="fs-6 text-secondary text-center">
    //       {openExpireModal && expiredMessage}
    //       {openInsufficientModal && insufficientMessage}
    //     </p>
    //     <Button
    //       icon={<IoFlash />}
    //       type="primary"
    //       href="/pricing"
    //       size="large"
    //       className="text-decoration-none bg-primary shadow-sm"
    //     >
    //       Upgrade Pro
    //     </Button>
    //   </div>
    // </Modal >
  );
};

export default WarningModal;